export default "__VITE_PUBLIC_ASSET__903f8608__"